import { render, staticRenderFns } from "./GiftCards.vue?vue&type=template&id=0b329cfa&scoped=true&"
import script from "./GiftCards.vue?vue&type=script&lang=js&"
export * from "./GiftCards.vue?vue&type=script&lang=js&"
import style0 from "./GiftCards.vue?vue&type=style&index=0&id=0b329cfa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b329cfa",
  null
  
)

export default component.exports